import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { BaseTemplate } from '../../components/templates';
import { Stack } from 'investira.react.components';
import AlertaMembrosList from './AlertaMembrosList';

const AlertaMembros = memo(() => {
  const xDefaultEntidadeStored = useSelector(store => store.entidade.current);
  return (
    <BaseTemplate
      title="Notificações de Usuários"
      subtitle={xDefaultEntidadeStored.entidade}
      maxWidth="lg">
      <Stack spacing={4}>
        <AlertaMembrosList />
      </Stack>
    </BaseTemplate>
  );
});

export default AlertaMembros;
